import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { Commercial, CommercialForm, Page, IdName } from '../models';

@Injectable()
export class CommercialService {

  commercialsUrl = environment.dns + 'api/commercials/';

  constructor(private http: HttpClient) { }

  getPaginateBySociety(societyId: number, page: number, size: number, search: string = ""): Observable<Page<Commercial>> {
    return this.http.get<Page<Commercial>>(this.commercialsUrl + 'paginate-by-society?societyId=' + societyId + '&page=' + page + '&size=' + size + "&search=" + encodeURIComponent(search));
  }

  getList(): Observable<Commercial[]> {
    return this.http.get<Commercial[]>(this.commercialsUrl + 'list');
  }

  getListBySociety(societyId: number): Observable<Commercial[]> {
    return this.http.get<Commercial[]>(this.commercialsUrl + 'list-by-society?societyId=' + societyId);
  }

  getOne(id: number): Observable<Commercial> {
    return this.http.get<Commercial>(this.commercialsUrl + id);
  }

  add(commercialForm: CommercialForm): Observable<Commercial> {
    return this.http.post<Commercial>(this.commercialsUrl, commercialForm);
  }

  update(commercialForm: CommercialForm): Observable<Commercial> {
    return this.http.put<Commercial>(this.commercialsUrl, commercialForm);
  }

  delete(id: number): Observable<boolean> {
    return this.http.delete<boolean>(this.commercialsUrl + id);
  }

  searchMin(q: string, page = 0, size = 20): Observable<Page<IdName>> {
    return this.http.get<Page<IdName>>(this.commercialsUrl + 'search?q=' + encodeURIComponent(q || '') + '&page=' + page + '&size=' + size);
  }
}
